import React from 'react'
import { Controller } from 'react-hook-form'
import YumSwitch from '../YumSwitch/YumSwitch'

type YumFormSwitchProps = {
  name: string
  control: any
  disabled?: boolean
  ariaLabel?: string
}

const YumFormSwitch = (props: YumFormSwitchProps) => {
  const { name, control, disabled, ariaLabel } = props
  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { value, ref, ...field } }) => (
        <YumSwitch
          {...field}
          role="switch"
          disabled={disabled}
          checked={!!value}
          inputRef={ref}
          inputProps={ariaLabel ? { 'aria-label': ariaLabel } : undefined}
        />
      )}
    />
  )
}

export default YumFormSwitch
